var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scout-tab-panel',{attrs:{"is-active":_vm.isActive,"link":_vm.link,"title":"会員検索","name":"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }